/**
 * The prefix for all class names in the design system.
 * we use BEM naming convention for class names.
 * @see https://en.bem.info/methodology/css/
 */
export const CLASS_NAME_PREFIX = "ads-v2";
export const CSS_VARIABLE_PREFIX = "--ads-v2-";
